import { createFileRoute } from "@tanstack/react-router"
import { OverviewPage } from "~/components/design-system/pages"
import { MarkdownPlanningTab } from "~/components/budget/planning/PlanningTabs"

export const Route = createFileRoute(
  "/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/markdown-planning",
)({
  component: RouteComponent,
})

function RouteComponent() {
  // fillContent: the grid scrolls inside itself, not the page.
  return (
    <OverviewPage fillContent>
      <MarkdownPlanningTab />
    </OverviewPage>
  )
}
